import React from 'react';
import { Helmet } from 'react-helmet';

const PageContainer = ({ title, description, children, additionalMetaTags = [] }) => {
  return (
    <div>
      <Helmet>
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}
        {additionalMetaTags.map((metaTag, index) => (
          <meta key={index} {...metaTag} />
        ))}
      </Helmet>
      {children}
    </div>
  );
};

export default PageContainer;
